import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

const textFaderIn = keyframes`
  from { opacity: 0; transform: translateY(25%); }
  to { opacity: 1; transform: translateY(0); }
`;

const textFaderOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-25%); }
`;

const TextFaderWrapper = styled.div`
  font-size: inherit;
  color: #fff;
  margin: 1rem;
`;

const TextContent = styled.div``;

const Line = styled.span.attrs(() => ({ className: 'line' }))`
  display: ${props => (props.isActive ? 'span' : 'none')};
  ${props => props.bold && 'font-weight: bold;'};
  opacity: 0;
  animation: ${props =>
    props.isActive
      ? css`
          ${textFaderIn} 0.8s ease forwards
        `
      : props.isOut
      ? css`
          ${textFaderOut} 2s ease forwards
        `
      : 'none'};

  .colour {
    margin: 0 0.5rem;
    .letter {
      color: ${({ textColor }) => textColor};
      transition: all 0.2s ease;
    }

    &.go .letter {
      color: ${({ textColor }) => textColor};
      ${props =>
        props.isActive &&
        Array.from({ length: 30 }).map(
          (_, i) => css`
            &:nth-child(${i + 1}) {
              transition-delay: ${0.07 * (i + 1)}s;
            }
          `,
        )}
    }
  }
`;

function ColourText({ text }) {
  return (
    <span className="colour">
      {text.split('').map((char, idx) => (
        <span className="letter" key={`letter-${idx}`}>
          {char}
        </span>
      ))}
    </span>
  );
}

export default function TextFader({ contents, textColor }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  useEffect(() => {
    const textFaderDelay = 2000;
    const textFaderAnimationSpeed = 900;
    const colourChangeDelay = 2000;

    const timeout2 = setTimeout(() => {
      setIsAnimatingOut(true);
      setTimeout(() => {
        setIsAnimatingOut(false);
        setActiveIndex(prev => (prev + 1) % contents.length);
      }, textFaderAnimationSpeed);
    }, textFaderDelay);

    return () => {
      clearTimeout(timeout2);
    };
  }, [activeIndex]);

  return (
    <TextFaderWrapper className="text-fader">
      <Line isActive={true}>We help you get</Line>
      {contents.map((line, i) => (
        <Line
          className="text-content"
          bold={true}
          key={`line-${i}`}
          isActive={i === activeIndex}
          isOut={isAnimatingOut && i === activeIndex}
          textColor={textColor}
        >
          <ColourText text={line} />
        </Line>
      ))}
      <Line isActive={true}>even without money.</Line>
    </TextFaderWrapper>
  );
}
